export const NODE_BG = '#161b22';

export const TYPE_COLORS = {
    text: '#52c41a',
    image: '#722ed1',
    video: '#f5222d',
    audio: '#fa8c16'
};

export const TYPE_ICONS = {
    text: 'FontSizeOutlined',
    image: 'PictureOutlined',
    video: 'VideoCameraOutlined',
    audio: 'SoundOutlined'
};

/**
 * Invisible handle style for edge-based connections.
 * Handles cover 60% of the node width to make connections easy from anywhere.
 * Left handles = left 60% of node (for inputs/targets)
 * Right handles = right 60% of node (for outputs/sources)
 * @param {string} position - 'left', 'right', 'left-top', 'left-bottom'
 */
export const getInvisibleHandleStyle = (position) => {
    const baseStyle = {
        background: 'transparent',
        border: 'none',
        borderRadius: 0,
        opacity: 0,
        cursor: 'crosshair',
    };

    // Left 60% of node - for target/input handles
    if (position === 'left') {
        return {
            ...baseStyle,
            left: 0,
            top: 0,
            width: '60%',
            height: '100%',
            transform: 'none',
        };
    }

    // Right 60% of node - for source/output handles
    if (position === 'right') {
        return {
            ...baseStyle,
            right: 0,
            top: 0,
            width: '60%',
            height: '100%',
            transform: 'none',
        };
    }

    // Split handles for multi-input nodes (top half / bottom half of left side)
    if (position === 'left-top') {
        return {
            ...baseStyle,
            left: 0,
            top: 0,
            width: '60%',
            height: '50%',
            transform: 'none',
        };
    }

    if (position === 'left-bottom') {
        return {
            ...baseStyle,
            left: 0,
            top: '50%',
            width: '60%',
            height: '50%',
            transform: 'none',
        };
    }

    return baseStyle;
};

// Legacy export for backwards compatibility - maps to invisible style
export const getHandleStyle = (typeColor, position, isVisible = false) => {
    return getInvisibleHandleStyle(position);
};

// No longer needed - handles are invisible
export const HANDLE_ICON_STYLE = {
    display: 'none'
};

